"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var utils_1 = require("../utils");

var evaluateColor_1 = require("./evaluateColor");

exports.evaluateStyle = function (style, variableDictionary) {
  var value = {};
  if (utils_1.hasValue(style.accentColor)) value.accentColor = evaluateColor_1.evaluateColor(style.accentColor, variableDictionary);
  if (utils_1.hasValue(style.backgroundColor)) value.backgroundColor = evaluateColor_1.evaluateColor(style.backgroundColor, variableDictionary);
  if (utils_1.hasValue(style.foregroundColor)) value.foregroundColor = evaluateColor_1.evaluateColor(style.foregroundColor, variableDictionary);
  if (utils_1.hasValue(style.highlightColor)) value.highlightColor = evaluateColor_1.evaluateColor(style.highlightColor, variableDictionary);
  if (utils_1.hasValue(style.shadowColor)) value.shadowColor = evaluateColor_1.evaluateColor(style.shadowColor, variableDictionary);
  return value;
};